import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import icons from 'assets/icons'

/**
 * Icon (Figma Icons 22:3687). Lấy SVG theo `name` từ registry `assets/icons`, tô bằng `color` (mặc định currentColor) qua CSS mask.
 * Dùng `original` để giữ màu gốc của file SVG (vd. icon nhiều màu).
 */
const Icon = React.forwardRef(({ name, size = 24, color = 'currentColor', original = false, sx, ...props }, ref) => {
  const src = icons[name]

  if (!src) {
    if (import.meta.env.DEV) console.warn(`Icon "${name}" not found in assets/icons`)
    return null
  }

  const baseSx = { display: 'block', flexShrink: 0, width: size, height: size }

  if (original) {
    return <Box ref={ref} component="img" src={src} alt="" aria-hidden sx={[baseSx, ...(Array.isArray(sx) ? sx : [sx])]} {...props} />
  }

  return (
    <Box
      ref={ref}
      component="span"
      aria-hidden
      sx={[
        baseSx,
        {
          bgcolor: color,
          maskImage: `url("${src}")`,
          maskSize: '100% 100%',
          maskRepeat: 'no-repeat'
        },
        ...(Array.isArray(sx) ? sx : [sx])
      ]}
      {...props}
    />
  )
})

Icon.displayName = 'Icon'

Icon.propTypes = {
  name: PropTypes.oneOf(Object.keys(icons)).isRequired,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string,
  original: PropTypes.bool,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
}

export default Icon
